var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardModalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 279,
    viewBox: "0 0 422 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.228 205.254L29.9313 131.156L0.292166 194.875L95.8698 239.333L67.5778 300.156L131.297 329.795L159.589 268.973L159.589 268.973L189.228 205.254ZM169.968 80.0368L329.265 154.135L299.626 217.853L226.875 374.254L163.156 344.615L235.907 188.214L140.329 143.756L169.968 80.0368ZM469.302 103.015L249.182 0.625343L219.543 64.3442L375.944 137.095L303.193 293.496L366.912 323.135L439.663 166.734L469.302 103.015Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.228 205.254L29.9313 131.156L0.292166 194.875L95.8698 239.333L67.5778 300.156L131.297 329.795L159.589 268.973L159.589 268.973L189.228 205.254ZM169.968 80.0368L329.265 154.135L299.626 217.853L226.875 374.254L163.156 344.615L235.907 188.214L140.329 143.756L169.968 80.0368ZM469.302 103.015L249.182 0.625343L219.543 64.3442L375.944 137.095L303.193 293.496L366.912 323.135L439.663 166.734L469.302 103.015Z",
    fill: "url(#paint0_linear_1540_3740)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1540_3740",
    x1: 45.4242,
    y1: 97.8491,
    x2: 395.878,
    y2: 260.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9C612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF930F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardModalLogo);
export default __webpack_public_path__ + "static/media/card-modal-logo.80c6872a1b8224177e5753ca6e27d388.svg";
export { ForwardRef as ReactComponent };